import { render } from "./AccessPage.vue?vue&type=template&id=4e935518&scoped=true"
import script from "./AccessPage.vue?vue&type=script&lang=js"
export * from "./AccessPage.vue?vue&type=script&lang=js"

import "./AccessPage.vue?vue&type=style&index=0&id=4e935518&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e935518"]])

export default __exports__